<template lang="pug">
  .etapa-analise-mra(v-if='etapaMRA')
    .linha
      b.coluna MRA - Módulo de regularização ambiental
    .linha
      .coluna
        collapse-component(title='Recuperação/Regeneração', :isBasic='true')
          .linha
            .coluna
              MraRecuperacaoRegTable(:recomposicoes="etapaMRA.recomposicoes", :tiposDocumentos='tiposDocumentos')
                .linha
                  .coluna Mapa de macrozoneamentos

              .coluna#mapa(style='margin: 15px 0px;')
                mapa-geo-car-wc(
                  ref='_infoMapa'
                  :id-imovel="$route.params.codigoImovelCriptografado",
                  :sicar-url='urlSicar',
                  :token='token',
                  @loadded="handleMapaCarregado"
                )

    .linha
      .coluna
        collapse-component(title='Compensação', :isBasic='true')
          .linha
            .coluna
              MraCompensacaoTable(
                :compensacoes="etapaMRA.compensacoes",
                :tiposDocumentos='tiposDocumentos'
              )

    .linha
      .coluna
        collapse-component(title='Sanções Administrativas', :isBasic='true')
          .linha
            .coluna
              MraSancoesAdmTable(
                :sancoesAdministrativas="etapaMRA.sancoesAdministrativas",
                :tiposDocumentos='tiposDocumentos',
                :codigoImovelCriptografado="$route.params.codigoImovelCriptografado",
                :codigoImovel="codigoImovel",
                :aderiuPra="!!$route.params?.aderiuPra"
              )
</template>

<script>

import {
    buscarEtapaMRA,
    salvar
} from '@/services/etapa-mra.service';
import { buscarPorId } from '@/services/processo.service';

import MraRecuperacaoRegTable from '@/views/analise/components/etapaMRA/MraRecuperacaoRegTable.vue';
import MraCompensacaoTable from '@/views/analise/components/etapaMRA/MraCompensacaoTable.vue';
import MraSancoesAdmTable from '@/views/analise/components/etapaMRA/MraSancoesAdmTable.vue';
import BUS from '@/utils/bus.utils';

export default {
    components: {
        MraRecuperacaoRegTable,
        MraCompensacaoTable,
        MraSancoesAdmTable,
    },
    props: {
        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            idProcesso: this.$route.params.id,
            etapaMRA: null,
            token: null,
            urlSicar: process.env.VUE_APP_SICAR_URL,
            alteracoes: [],

            etapaMRAInicial: null,
            codigoImovel: null,
        };
    },
    async mounted() {
        if (this.$route.params?.aderiuPra) {
            this.token = process.env.VUE_APP_TOKEN_MAPA_SICAR_COM_PRA;
        } else {
            this.token = process.env.VUE_APP_TOKEN_MAPA_SICAR_SEM_PRA;
        }
        try {
            this.etapaMRA = await buscarEtapaMRA(this.$route.params.id);
            // Buscar código do imóvel do processo
            // EtapaMRA não retorna processo no JSON (@JsonIgnoreProperties), então sempre buscar separadamente
            try {
                const processo = await buscarPorId(this.$route.params.id);
                this.codigoImovel = processo?.codigoImovel || processo?.codigo_imovel;
            } catch (err) {
                console.error('Erro ao buscar código do imóvel:', err);
            }
        } catch {
            this.$router.push({ name: 'analise-proposta' });
        }
    },
    methods: {
        async salvar() {
            const processo = await salvar(this.idProcesso, this.etapaMRA);
            if (processo) {
                this.$toast({
                    showClose: true,
                    message: 'Informações salvas com sucesso!',
                    type: 'success'
                });
                return processo;
            } else {
                return this.etapaMRA.processo;
            }
        },
        handleMapaCarregado(dadosMapa) {
            dadosMapa.srcElement._wrapper.$refs.inner.disableTools();
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 600);
            BUS.$emit('loading:hide');
        },
        registrarAlteracoes(objAtual, objInicial, path) {
            for (let key in objAtual) {
                if (typeof objAtual[key] === 'object' && objAtual[key] !== null && !Array.isArray(objAtual[key])) {
                // Recursivamente compara objetos aninhados
                    this.registrarAlteracoes(objAtual[key], objInicial[key], `${path}${key}.`);
                } else if (Array.isArray(objAtual[key])) {
                // Comparar arrays
                    for (let i = 0; i < objAtual[key].length; i++) {
                        const pathIndex = `${path}${key}[${i}].`;
                        this.registrarAlteracoes(objAtual[key][i], objInicial[key][i], pathIndex);
                    }
                } else {
                // Comparar campos simples apenas se forem diferentes e existirem alterações
                    if (objAtual[key] !== objInicial[key] && objInicial[key] !== undefined) {
                        this.alteracoes.push(`Campo ${path}${key} alterado de ${objInicial[key]} para ${objAtual[key]}`);
                    }
                }
            }
        },
        capturarAlteracoes(novasAlteracoes) {
        // Recebe as alterações do componente filho
            this.alteracoes = novasAlteracoes;
        },
    },

    watch: {
        etapaIARA: {
            deep: true,
            handler(novoValor) {
                if (!this.etapaMRAInicial) {
                // Se etapaIARAInicial ainda não foi definido, define-o agora
                    this.etapaMRAInicial = JSON.parse(JSON.stringify(novoValor));
                }
            }
        }
    }
};
</script>

<style scoped>
.titulo {
    padding: 40px 0px;
    font-weight: 600;
    font-size: 14px;
    color: var(--primary-black);
}

.mapa-iara {
    margin-right: 15px;
    color: var(--primary-black) !important;
}

.button-left {
    margin-right: 15px;
    padding: 0px 8px;
}

.documento-iara {
    color: var(--primary-green) !important;
}

.link {
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
}

.divisor {
    border-bottom: 1px solid var(--primary-dark-smoke);
    margin: 50px 0px 30px 0px;
}

#mapa {
    height: 400px;
    z-index: 0;
}
</style>
